<!-- bottom-menu.component.html -->
<nav class="bottom-menu" *ngIf="isMobile">
  <div class="menu-container">
    <a class="menu-item" [class.active]="currentRoute === '/'" routerLink="/">
      <i class="fa-house-user fas"></i>
      <span>Inicio</span>
    </a>

    <a
      class="menu-item"
      [class.active]="currentRoute === '/mis-citas'"
      routerLink="/mis-citas"
    >
      <i class="fa-calendar-check fas"></i>
      <span>Mis Citas</span>
    </a>

    <a
      class="menu-item"
      [class.active]="currentRoute === '/citas-new'"
      routerLink="/citas-new"
    >
      <i class="fa-plus fas"></i>
      <span>Nueva Cita</span>
    </a>

    <a
      class="menu-item"
      [class.active]="currentRoute === '/perfil'"
      routerLink="/perfil"
    >
      <i class="fa-user fas"></i>
      <span>Mi Cuenta</span>
    </a>
  </div>
</nav>
